export default {
	getTransportServiceById: state => transportServiceId =>
		state.reservationModel.transportServices.find(
			({ id }) => id === transportServiceId
		)
};
